<template>
  <div id="app">
    <router-view />
	<Footer></Footer>
  </div>
</template>

<script>
import Footer from '/src/components/Footer.vue'
export default {
  name: 'App',
  components: {
	  Footer
  }
}
</script>

<style>
body {
	padding: 0;
	margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
ul {
	list-style: none;
	padding: 0;
	margin: 0;
}
</style>
